import { clone } from 'ramda';

import { getRangeValue, resetTerms, setRangeMin, setTerm } from './helpers';
import { EBalconyType, type NonEmptyArray, type TJsonQuery } from './types';

export function setBalconyTypes(jsonQuery: TJsonQuery) {
  return (balconyTypes: NonEmptyArray<EBalconyType> | null): TJsonQuery => {
    let nextJsonQuery = clone(jsonQuery);

    nextJsonQuery = resetTerms(['balconies', 'loggia'])(nextJsonQuery);

    if (balconyTypes) {
      if (balconyTypes.includes(EBalconyType.Balcony)) {
        const balconies = getRangeValue('balconies')(jsonQuery);

        nextJsonQuery = setRangeMin('balconies')(nextJsonQuery)((balconies && balconies.gte) || 1);
      }

      if (balconyTypes.includes(EBalconyType.Loggia)) {
        nextJsonQuery = setTerm('loggia')(nextJsonQuery)(true);
      }
    }

    return nextJsonQuery;
  };
}
